module.exports = "/React/dist/43c3241989c09606a2e6414f517d6024.png";